
const companyInfo = {
    name: "Shaanxi Xun Dan Bao Digital Intelligent Technology Co., Ltd",
    products: 'Gates drills/Pesso reamers, Fiber post drills, Gutta percha/Paper point, all systems of NITI Rotary files etc.',
    overview: ". After nearly ten years of precipitation and growth of the industry, our company has a strong R&D and manufacturing capacity and efficent detection means.At present, VIDEYA cover a full range of endodonstic instruments: K/H/R files, Spreader/Plugger, Paste carriers, Barbed broaches, Gates drills/Pesso reamers, Fiber post drills, Gutta percha/Paper point, all systems of NITI Rotary files etc."
}
const videoSrc = "http://obbin.oss-cn-hangzhou.aliyuncs.com/无界.mp4"
export default {
    data() {
        return {
            videoSrc,
            companyInfo
        }
    }
}
